import styled from 'styled-components'

export const Wrapper = styled.iframe`
  height: 99.2vh;
  width: 100vw;
`
